import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { RESEARCH } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/research/")({
  component: () => <DeptContentList cfg={RESEARCH} />,
});
